var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompletion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.471,
    height: 78.471,
    viewBox: "0 0 78.471 78.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7562",
    "data-name": "Group 7562",
    transform: "translate(20677 -14247.354)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 39.235,
    cy: 39.235,
    r: 39.235,
    transform: "translate(-20677 14247.354)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_278",
    "data-name": "Ellipse 278",
    cx: 32.696,
    cy: 32.696,
    r: 32.696,
    transform: "translate(-20670.461 14253.893)",
    fill: "#a997df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9405",
    "data-name": "Path 9405",
    d: "M317.7,260.953q-.088,0-.176,0a3.59,3.59,0,0,1-2.661-1.383l-5.015-6.448a3.6,3.6,0,0,1,.63-5.042l.18-.14a3.6,3.6,0,0,1,5.043.63,3.2,3.2,0,0,0,4.843.236l10.184-10.75a3.593,3.593,0,0,1,5.08-.137l.166.158a3.593,3.593,0,0,1,.137,5.079l-15.8,16.68A3.589,3.589,0,0,1,317.7,260.953Z",
    transform: "translate(-20958.246 14037.459)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletion);
export default __webpack_public_path__ + "static/media/completion.0b47a2bbb3c8a984ed7a5ba133b2f657.svg";
export { ForwardRef as ReactComponent };